import type React from 'react';
import classes from './employee-avatar.module.scss';

export const EmployeeAvatar: React.FC<{
  firstName: string;
  lastName: string;
  photoUrl?: string | null;
}> = ({ firstName, lastName, photoUrl }) => {
  const initials = `${firstName.trim().charAt(0)}${lastName.trim().charAt(0)}` || 'ע';

  return (
    <span className={classes.employeeAvatar} aria-hidden="true">
      {photoUrl ? <img src={photoUrl} alt="" /> : initials}
    </span>
  );
};
